var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":"https://third-image.oss-cn-hangzhou.aliyuncs.com/ea8d3fb4aee347a09e8d9cc4271c29ae.pdf","frameborder":"0"}})])}]

export { render, staticRenderFns }